import { Flex, Loader } from "@mantine/core";

// Shown while a route transition is pending (chunk loads, beforeLoad work).
// Mirrors SuspenseWrapper's fallback so in-page and route-level loading look
// the same.
const RoutePending = () => (
  <Flex justify="center" align="center" mih="400px" w="100%">
    <Loader />
  </Flex>
);

export default RoutePending;
